/**
 * StagingBanner — Fixed banner at top of page for staging environments.
 * Only renders when hostname is staging.tabletryb.com or localhost.
 * Self-contained styling (no external CSS needed).
 */

import React from 'react';

const StagingBanner: React.FC = () => {
  const hostname = window.location.hostname;
  const isStaging = hostname === 'staging.tabletryb.com' || hostname === 'localhost';

  if (!isStaging) return null;

  return (
    <div style={{
      background: '#f59e0b',
      color: '#000',
      textAlign: 'center',
      padding: '6px 12px',
      fontSize: '13px',
      fontWeight: 600,
      fontFamily: 'Inter, sans-serif',
      letterSpacing: '0.02em',
      position: 'sticky',
      top: 0,
      zIndex: 9999,
    }}>
      This is TableTryb Staging Site – For Testing Purposes Only
    </div>
  );
};

export default StagingBanner;
